import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import PubSub from 'services/PubSub/';
import ProductPrices from 'components/ProductPrices';
import ImageLoad from 'components/ImageLoad';
import ProductFlags from 'components/ProductFlags';
import notImage from 'images/foto_en_preparacion.png';
import TagManagerService from 'services/TagManager';
import { translateFlag } from 'config/constants';
import StorageService from 'services/StorageService';
import ProductFactory from 'factories/Products';
import Checkbox from 'components/Forms/Inputs/ChecksGroup/checkbox';
import { getImageV2, slugify, elipsis } from 'utils';
import { withRouter } from "react-router";
import { actionsType } from 'config/constants';
import style from './style.scss';//NOSONAR

const ShelfTogether = (props) => {
    let controlsConfig = null;
    const product = props.product;
    const item = product.items ? product.items[0] : false;
    const notPDP = props.notPDP;
    const withCheckbox = props.withCheckbox;
    const mobileVersion = props.mobileVersion;

    const [load] = useState(null);
    const [checkbox, setCheck] = useState(true);

    if (item) {
        controlsConfig = {
            unitSale: (product['Pesable x Unidad'] && product['Pesable x Unidad'][0]) ? translateFlag[product['Pesable x Unidad'][0]] : false,
            unitMultiplier: item.unitMultiplier,
            measurementUnit: item.measurementUnit,
            maxItems: item.maxItems - (item.inCart ? item.inCart : 0),
            customClass: props.small ? props.small : false,
            tagManagerData: { product: product, listTitle: props.listTitle, position: props.position }
        };
    }

    const openPreView = (prod) => {
        PubSub.dispatch('open_product_preview', { product: prod, title: props.listTitle, position: props.position });
    }

    const openModalAddToList = (itemID) => {
        PubSub.dispatch(actionsType.DRAWER.ADDTO_LIST_OPEN, { skuId: itemID, config: controlsConfig });
    }

    const producRedirect = () => {
        PubSub.dispatch('product_redirect');
    }

    const productClick = () => {
        TagManagerService.productClick(props.product, props.listTitle, props.position);

        StorageService.setItem('list_pdp', props.listTitle);
    }
    useEffect(() => {
        if(item && withCheckbox){
            PubSub.dispatch('checkbox-products-together', {skuId: item.itemId, value: checkbox});
        }
    },[checkbox])

    const handleCheckbox = () => {
        setCheck(!checkbox)
    }

    const goToBrand = (brand) => {
        const formatBrand = slugify(brand);
        props.history.push(`/${formatBrand}`);
        TagManagerService.interaction("Click Marca", brand, product?.categories[0]);
    }

    const skuData = item && product.SkuData && product.SkuData[item.itemId] ? product.SkuData[item.itemId] : {};
    const productImage = item ? getImageV2(item, 150) : product.ImageUrl;
    const link = notPDP ? '#' : (product.linkText ? `/${product.linkText}/p` : '');
    const stock = item ? ProductFactory.hasStock(item) : false;
    const limitTitle = props.limitTitle || 49;

    const productName = product.productName || product.ProductName;
    if (item) {
        item.skuData = item.skuData || {};
    }

    const extraActions = (
        <div className="shelf-product-extra-actions">
            {item && <button className="font-icn view-more tooltip-container mobile-click" onClick={() => openPreView(product)}>
                <span className="tooltip">Vista Rápida</span>
            </button>}
            <button className="tooltip-container mobile-click" onClick={() => openModalAddToList(item.itemId || product.Id)}>
                <i className="add-list-icon jumbo-icon-new-list"></i>
                <span className="tooltip">Agregar a una lista</span>
            </button>
        </div>
    );
    const unitMeasurement = item ? ProductFactory.formatWeight(item.measurementUnit, item.unitMultiplier) : '';

    return (
        <div className={"shelf-product-together"+ (withCheckbox && !checkbox ? ' not-checked ' : '') + (mobileVersion ? ' mobile-version ' : '')}>
            {withCheckbox  && <Checkbox
                name={'product-together'}
                checked={checkbox}
                onChange={handleCheckbox}
            />}
            <div className={"shelf-product-top-together"} onClick={() => producRedirect()}>
                <div className="shelf-product-image-together">
                    {!load && extraActions}
                    <Link to={link} onClick={productClick} className="shelf-wrap-image-together" aria-label={productName}>
                        {productImage && <ImageLoad src={productImage} errorImage={notImage} alt={productName} gtmData={props.gtmData} />}
                        {!productImage && <ImageLoad src={notImage} errorImage={notImage} alt={productName} gtmData={props.gtmData} />}
                    </Link>
                </div>
            </div>
            <div className={"container-shelf-info-product-together"+ (mobileVersion ? ' mobile-version ' : '')}>
                <div className="shelf-info-product">
                    {item && <ProductFlags item={item} nutritionalTag={true} stock={stock} />}
                    <Link to={link} onClick={productClick} title={productName} className="shelf-together-title"><h2>{elipsis(productName, limitTitle)}</h2></Link>
                    {(!!item.unitMultiplier) && <span className="shelf-single-unit">{unitMeasurement}</span>}
                    <a onClick={(()=> goToBrand(product?.brand))} title={product?.brand} className="shelf-product-brand">{product.brand}</a>
                </div>
                {stock && <ProductPrices item={item} skuData={skuData} onlyCurrentPrice={true} productDetail={false} />}
            </div>

        </div>
    )
}

ShelfTogether.propTypes = {
    product: PropTypes.object,
    small: PropTypes.bool,
    listTitle: PropTypes.string,
    position: PropTypes.number,
    item: PropTypes.object,
    limitTitle: PropTypes.number,
    callback: PropTypes.func,
    qtyInit: PropTypes.string,
    notPDP: PropTypes.bool,
    gtmData: PropTypes.object,
};

export default withRouter(ShelfTogether)
